<div class="grid grid-cols-1 md:grid-cols-12 gap-6 mb-6">
  <div class="bg-white rounded-lg shadow-lg md:col-span-6 p-6">
    <div class="flex justify-between content-center mb-6">
      <h2 class=" font-semibold card-heading text-[#0058e9]">API Usage Matrix</h2>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
      >
        <path
          d="M8.75471 5.74989C8.59065 5.74989 8.45165 5.80686 8.33772 5.92079C8.22379 6.03472 8.16682 6.17372 8.16682 6.33778C8.16682 6.50185 8.22379 6.63857 8.33772 6.74794C8.45165 6.85732 8.59065 6.912 8.75471 6.912H12.2547C12.4188 6.912 12.5555 6.85732 12.6649 6.74794C12.7742 6.63857 12.8289 6.50185 12.8289 6.33778V2.83778C12.8289 2.67372 12.7742 2.53472 12.6649 2.42079C12.5555 2.30686 12.4188 2.24989 12.2547 2.24989C12.0907 2.24989 11.9517 2.30686 11.8377 2.42079C11.7238 2.53472 11.6668 2.67372 11.6668 2.83778V5.74989H8.75471ZM10.2313 9.05849C9.86669 10.052 9.26285 10.829 8.41975 11.3895C7.57665 11.9501 6.62646 12.2076 5.56917 12.162C4.51188 12.08 3.59586 11.7131 2.82112 11.0614C2.04638 10.4097 1.53596 9.56435 1.28987 8.52528C1.07112 7.49534 1.1691 6.5178 1.58382 5.59267C1.99853 4.66754 2.66617 3.94065 3.58675 3.412C4.51643 2.91982 5.48486 2.74436 6.49202 2.88564C7.49918 3.02691 8.38102 3.46669 9.13753 4.20497L11.8446 6.76161C11.9722 6.87099 12.1134 6.9234 12.2684 6.91884C12.4233 6.91428 12.5578 6.85048 12.6717 6.72743C12.7856 6.60439 12.8403 6.46539 12.8358 6.31044C12.8312 6.15549 12.7697 6.02333 12.6512 5.91396L9.94417 3.37099C9.00537 2.45041 7.90934 1.90126 6.65608 1.72353C5.40283 1.54579 4.19287 1.76682 3.0262 2.38661C1.86865 3.05198 1.0301 3.96116 0.510574 5.11415C-0.00895746 6.26715 -0.132004 7.49078 0.141433 8.78505C0.460444 10.0793 1.10302 11.1343 2.06917 11.9501C3.03531 12.7658 4.17919 13.2239 5.50081 13.3241C6.82242 13.3788 8.0096 13.0575 9.06233 12.3602C10.1151 11.663 10.8739 10.69 11.3387 9.4413C11.3843 9.28635 11.3752 9.13824 11.3114 8.99696C11.2476 8.85569 11.1382 8.75771 10.9832 8.70302C10.8283 8.64833 10.6802 8.65517 10.5389 8.72353C10.3976 8.79189 10.2951 8.90354 10.2313 9.05849Z"
          fill="#6B6F82"
        />
      </svg>
    </div>
      <app-line-chart
        class="w-full flex items-end"
        [chartData]="apiUsageMatrixChartData"
        [xAxisTitle]="'Time'"
        [yAxisTitle]="'No. of API Calls'"
      >
      </app-line-chart>
  </div>
  <div class="bg-white rounded-lg shadow-lg md:col-span-6 p-6">
    <h2 class="text-[16px] text-[#FF3A6E]  font-bold"> Error Analysis </h2>
    <app-bar-chart
        class="w-full h-full flex items-end"
        [xAxisTitle]="'Error Types'"
        [yAxisTitle]="'No. of Errors'"
        [chartData]="userRegistrationBarChartData">
    </app-bar-chart>
  </div>

  <div class="bg-white rounded-lg shadow-lg md:col-span-12 px-12 py-6" >
    <h2 class="text-[16px] text-[#0058e9]  font-bold"> API Catalogue Usage </h2>
        <canvas baseChart
        [type]="'pie'"
        [datasets]="pieChartDatasets"
        [labels]="pieChartLabels"
        [options]="pieChartOptions"
        [plugins]="pieChartPlugins"
        [legend]="true">
        </canvas>
    </div>

    <div class="bg-white rounded-lg shadow-lg md:col-span-6 p-6">
        <h2 class="text-[16px] text-[#0058e9]  font-bold">Service Request</h2>
        <app-bar-chart
            class="w-full h-full flex items-end"
            [xAxisTitle]="'No. of Service Request'"
            [yAxisTitle]="'No. of Service Request'"
            [chartData]="serviceBarChartData">
        </app-bar-chart>
    </div>

    <div class="bg-white rounded-lg shadow-lg md:col-span-6 p-6">
        <h2 class="text-[16px] text-[#0058e9]  font-bold"> User Trends </h2>
            <app-line-chart
              class="w-full h-full flex items-end"
              [chartData]="apiUsageLineChartData"
              [xAxisTitle]="'Time'"
              [yAxisTitle]="'Usage Frequency'"
            ></app-line-chart>
    </div>
</div>